module.exports = __webpack_public_path__ + "media/flags/en-b9a2ba74.png";